export default{
  isResponsive:true,
  label:'display',
  prefix:'d',
  steps:[
    'none', 
    'inline',
    'inline-block',
    'block',
    'table',
    'table-cell',
    'table-row',
  ]
}


// WEBPACK FOOTER //
// ./src/shell/schemas/utilities/display.js